import moment from "moment";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";

// Custom hook for navigation
export const useUnauthorizedNavigation = () => {
  const navigate = useNavigate();

  const [, , removeCookie] = useCookies(["reebukToken"]);
  const handleUnauthorizedNavigation = () => {
    navigate("/auth/Login");
    removeCookie("reebukToken", {
      path: "/",
      secure: true,
      httpOnly: false,
      sameSite: "Strict",
    });
  };

  return handleUnauthorizedNavigation;
};

export const getGreeting = () => {
  const hour = moment().hour(); // Get current UTC hour

  if (hour >= 5 && hour < 12) {
    return "Good Morning!";
  } else if (hour >= 12 && hour < 17) {
    return "Good Afternoon!";
  } else if (hour >= 17 && hour < 21) {
    return "Good Evening!";
  } else {
    return "Good Night!";
  }
};

export const getUniqueValues = (data, key) => {
  return [...new Set(data.map((item) => item[key]))];
};
